import { render, staticRenderFns } from "./ProjectTradieRequestedFileList.vue?vue&type=template&id=2b6f3471&scoped=true"
import script from "./ProjectTradieRequestedFileList.vue?vue&type=script&lang=js"
export * from "./ProjectTradieRequestedFileList.vue?vue&type=script&lang=js"
import style0 from "./ProjectTradieRequestedFileList.vue?vue&type=style&index=0&id=2b6f3471&prod&lang=scss&scoped=true"
import style1 from "./ProjectTradieRequestedFileList.vue?vue&type=style&index=1&id=2b6f3471&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f3471",
  null
  
)

export default component.exports